var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"value":_vm.show,"z-index":_vm.zIndex}},[_c('v-progress-circular',{attrs:{"size":70,"width":7,"color":"indigo","indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }